/**
 * Category Aside Toggle
 * Collapsible category sidebar navigation
 */

(function () {
  'use strict';

  // Initialize category toggle
  function initCategoryToggle() {
    const asides = document.querySelectorAll('.js-category-aside');
    if (!asides.length) return;

    asides.forEach(function (aside) {
      const toggle = aside.querySelector('.js-category-toggle');
      const list = aside.querySelector('.js-category-list');

      if (!toggle || !list || toggle.dataset.categoryToggleInit === 'true') return;

      toggle.dataset.categoryToggleInit = 'true';

      // Toggle handler
      toggle.addEventListener('click', function () {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const newState = !expanded;

        toggle.setAttribute('aria-expanded', String(newState));
        aside.classList.toggle('closed', !newState);
      });
    });
  }

  function initStickyButtonVisibility() {
    const stickyButtons = document.querySelectorAll('a.stickyButton.isHeroPresent');
    if (!stickyButtons.length) return;

    const hero =
      document.querySelector('.hero') ||
      document.querySelector('.heroSection') ||
      document.querySelector('.pt-001-mainBanner');

    // Fallback when hero selector is unavailable.
    if (!hero) {
      const updateByScroll = function () {
        const isVisible = window.scrollY > 150;
        stickyButtons.forEach(function (btn) {
          btn.classList.toggle('visible', isVisible);
        });
      };

      window.addEventListener('scroll', updateByScroll, { passive: true });
      updateByScroll();
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        const isHeroVisible = entries[0] && entries[0].isIntersecting;
        stickyButtons.forEach(function (btn) {
          btn.classList.toggle('visible', !isHeroVisible);
        });
      },
      {
        threshold: 0.01,
      }
    );

    observer.observe(hero);
  }

  function initHeaderVisibilityForCategoryLayout() {
    const header = document.querySelector('.header');
    if (!header) return;

    const section =
      document.querySelector('.category-example-layout');

    if (!section) return;

    const observer = new IntersectionObserver(
      function (entries) {
        const isVisible = entries[0] && entries[0].isIntersecting;
        header.classList.toggle('hidden', isVisible);
      },
      {
        threshold: 0.01,
      }
    );

    observer.observe(section);
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCategoryToggle();
      initStickyButtonVisibility();
      initHeaderVisibilityForCategoryLayout();
    });
  } else {
    initCategoryToggle();
    initStickyButtonVisibility();
    initHeaderVisibilityForCategoryLayout();
  }
})();
